module.exports = "/desktop-app/assets/img/order.svg?79214533cb0b66f721216257d6871e2c";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/order.svg
// module id = 3Wje
// module chunks = 1